module.exports = __webpack_public_path__ + "img/arrow-back.c7604979.svg";